/* eslint-disable @tanstack/query/exhaustive-deps --
   Keep the data API out of query keys. It is only used inside `queryFn`, and
   PlatformDataApi contains a circular Auth0 client that breaks key serialization.
   Real cache inputs are still included in each key.  */
import { queryOptions } from "@tanstack/react-query";

import { ISharedDataApi } from "../types";

export const getOrganizationListQueryOptions = (dataApi: ISharedDataApi) =>
  queryOptions({
    queryKey: ["organizations"],
    queryFn: () => {
      return dataApi.getOrganizationList();
    },
  });

export const getSubstationByOrganizationQueryOptions = (
  dataApi: ISharedDataApi,
  orgId?: string,
  { enabled = true }: { enabled?: boolean } = { enabled: true }
) =>
  queryOptions({
    queryKey: ["organization", "substations", orgId],
    queryFn: () => {
      return dataApi.getSubstationByOrganization(orgId);
    },
    enabled: !!orgId && !!dataApi && !!enabled,
  });
